import { useAppSelector } from 'hooks/reduxHooks'
import { getFinestLocationSearchUrl } from './getFinestLocationSearchUrl'

export function getRelatedTravelItemsByOfferId(state: App.State, offerId: string) {
  return state.offer.relatedTravelItems[offerId]
}

function useFinestLocationSearchUrl(offerId: string) {
  const relatedTravelItems = useAppSelector(state => getRelatedTravelItemsByOfferId(state, offerId))
  return getFinestLocationSearchUrl(relatedTravelItems)
}

export default useFinestLocationSearchUrl
